import packageJson from './../../package.json';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
var configSettings = require('../../app-config/config');
var config = configSettings.GET_CONFIG();
var connectionString = config.AICONNECTIONSTRING;
var appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    disableExceptionTracking: false
  }
});
appInsights.loadAppInsights();
appInsights.trackPageView();
appInsights.context.application.ver = packageJson.version;
export { appInsights };